/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CoachTaskAction interface.
 */
export function instanceOfCoachTaskAction(value) {
    if (!("id" in value) || value.id === undefined)
        return false;
    if (!("title" in value) || value.title === undefined)
        return false;
    if (!("canCompleteDirectly" in value) ||
        value.canCompleteDirectly === undefined)
        return false;
    return true;
}
export function CoachTaskActionFromJSON(json) {
    return CoachTaskActionFromJSONTyped(json, false);
}
export function CoachTaskActionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json.id,
        title: json.title,
        canCompleteDirectly: json.canCompleteDirectly,
    };
}
export function CoachTaskActionToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value.id,
        title: value.title,
        canCompleteDirectly: value.canCompleteDirectly,
    };
}
